var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCopyclipboard = function SvgCopyclipboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2383 16H5.01172V5.48828H13.2383V16ZM13.2383 4.01172H5.01172C4.58984 4.01172 4.22656 4.16406 3.92188 4.46875C3.64062 4.75 3.5 5.08984 3.5 5.48828V16C3.5 16.4219 3.64062 16.7734 3.92188 17.0547C4.22656 17.3594 4.58984 17.5117 5.01172 17.5117H13.2383C13.6602 17.5117 14.0117 17.3594 14.293 17.0547C14.5977 16.7734 14.75 16.4219 14.75 16V5.48828C14.75 5.08984 14.5977 4.75 14.293 4.46875C14.0117 4.16406 13.6602 4.01172 13.2383 4.01172ZM10.9883 0.988281H1.98828C1.58984 0.988281 1.23828 1.14062 0.933594 1.44531C0.652344 1.72656 0.511719 2.07812 0.511719 2.5V13.0117H1.98828V2.5H10.9883V0.988281Z",
    fill: "#8DA3C5"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopyclipboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copyclipboard.6190f390.svg";
export { ForwardRef as ReactComponent };